import React, { useState } from 'react';
import { Code, FileText, Save, X } from 'lucide-react';

const HFCM: React.FC = () => {
  const [formData, setFormData] = useState({
    snippetName: '',
    snippetType: 'HTML',
    siteDisplay: 'Site Wide',
    excludePages: '',
    excludePosts: '',
    location: 'Header',
    deviceDisplay: 'Show on All Devices',
    status: 'Active',
    snippetCode: ''
  });

  const handleInputChange = (field: string, value: string) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Handle form submission here
    console.log('Form Data:', formData);
  };

  const handleReset = () => {
    setFormData({
      snippetName: '',
      snippetType: 'HTML',
      siteDisplay: 'Site Wide',
      excludePages: '',
      excludePosts: '',
      location: 'Header',
      deviceDisplay: 'Show on All Devices',
      status: 'Active',
      snippetCode: ''
    });
  };

  return (
    <div className="p-6 overflow-visible">
      <div className="bg-white rounded-lg shadow-md border overflow-visible">
        <div className="p-6 border-b border-gray-200">
          <div className="flex items-center gap-3">
            <Code className="w-6 h-6 text-blue-600" />
            <h1 className="text-2xl font-bold text-gray-900">HFCM</h1>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="p-6 space-y-6 overflow-visible">
          {/* Snippet Name */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Snippet Name
            </label>
            <input
              type="text"
              value={formData.snippetName}
              onChange={(e) => handleInputChange('snippetName', e.target.value)}
              placeholder="Enter snippet name"
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
          </div>

          {/* Snippet Type */}
          <div className="relative">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Snippet Type
            </label>
            <select
              value={formData.snippetType}
              onChange={(e) => handleInputChange('snippetType', e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent appearance-none bg-white relative z-10"
              style={{ 
                backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3E%3Cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='M6 8l4 4 4-4'/%3E%3C/svg%3E")`,
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'right 0.5rem center',
                backgroundSize: '1.5em 1.5em',
                paddingRight: '2.5rem'
              }}
            >
              <option value="HTML">HTML</option>
              <option value="CSS">CSS</option>
              <option value="JavaScript">JavaScript</option>
            </select>
          </div>

          {/* Site Display */}
          <div className="relative">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Site Display
            </label>
            <select
              value={formData.siteDisplay}
              onChange={(e) => handleInputChange('siteDisplay', e.target.value)}
              className="w-full px-3 py-2 border border-blue-500 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent appearance-none bg-white relative z-10"
              style={{ 
                backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3E%3Cpath stroke='%233b82f6' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='M6 8l4 4 4-4'/%3E%3C/svg%3E")`,
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'right 0.5rem center',
                backgroundSize: '1.5em 1.5em',
                paddingRight: '2.5rem'
              }}
            >
              <option value="Site Wide">Site Wide</option>
              <option value="Homepage Only">Homepage Only</option>
              <option value="Specific Pages">Specific Pages</option>
            </select>
          </div>

          {/* Exclude Pages */}
          {/* <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Exclude Pages
            </label>
            <input
              type="text"
              value={formData.excludePages}
              onChange={(e) => handleInputChange('excludePages', e.target.value)}
              placeholder="Enter page IDs or paths to exclude (comma separated)"
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
          </div> */}

          {/* Exclude Posts */}
          {/* <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Exclude Posts
            </label>
            <input
              type="text"
              value={formData.excludePosts}
              onChange={(e) => handleInputChange('excludePosts', e.target.value)}
              placeholder="Enter post IDs or paths to exclude (comma separated)"
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
          </div> */}

          {/* Location */}
          <div className="relative">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Location
            </label>
            <select
              value={formData.location}
              onChange={(e) => handleInputChange('location', e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent appearance-none bg-white relative z-10"
              style={{ 
                backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3E%3Cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='M6 8l4 4 4-4'/%3E%3C/svg%3E")`,
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'right 0.5rem center',
                backgroundSize: '1.5em 1.5em',
                paddingRight: '2.5rem'
              }}
            >
              <option value="Header">Header</option>
              <option value="Footer">Footer</option>
            </select>
            <p className="mt-1 text-xs text-gray-500">
              Not all locations (such as before content) exist on all page/post types. The location will only appear as an option if the appropriate hook exists on the page.
            </p>
          </div>

          {/* Device Display */}
          <div className="relative">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Device Display
            </label>
            <select
              value={formData.deviceDisplay}
              onChange={(e) => handleInputChange('deviceDisplay', e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent appearance-none bg-white relative z-10"
              style={{ 
                backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3E%3Cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='M6 8l4 4 4-4'/%3E%3C/svg%3E")`,
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'right 0.5rem center',
                backgroundSize: '1.5em 1.5em',
                paddingRight: '2.5rem'
              }}
            >
              <option value="Show on All Devices">Show on All Devices</option>
              <option value="Desktop Only">Desktop Only</option>
              <option value="Mobile Only">Mobile Only</option>
              <option value="Tablet Only">Tablet Only</option>
            </select>
          </div>

          {/* Status */}
          <div className="relative">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Status
            </label>
            <select
              value={formData.status}
              onChange={(e) => handleInputChange('status', e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent appearance-none bg-white relative z-10"
              style={{ 
                backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3E%3Cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='M6 8l4 4 4-4'/%3E%3C/svg%3E")`,
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'right 0.5rem center',
                backgroundSize: '1.5em 1.5em',
                paddingRight: '2.5rem'
              }}
            >
              <option value="Active">Active</option>
              <option value="Inactive">Inactive</option>
            </select>
          </div>

          {/* Snippet/Code Editor */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Snippet / Code
            </label>
            <div className="border border-gray-300 rounded-lg overflow-hidden">
              <div className="bg-gray-50 px-4 py-2 border-b border-gray-300 flex items-center gap-2">
                <FileText className="w-4 h-4 text-gray-600" />
                <span className="text-sm font-medium text-gray-700">Snippet / Code</span>
              </div>
              <textarea
                value={formData.snippetCode}
                onChange={(e) => handleInputChange('snippetCode', e.target.value)}
                placeholder="Enter your code here..."
                className="w-full px-4 py-3 font-mono text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 resize-none"
                rows={15}
                style={{
                  fontFamily: 'monospace',
                  lineHeight: '1.5',
                  tabSize: 2
                }}
              />
            </div>
          </div>

          {/* Form Actions */}
          <div className="flex items-center gap-4 pt-4 border-t border-gray-200">
            <button
              type="submit"
              className="flex items-center gap-2 px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
            >
              <Save className="w-4 h-4" />
              Save
            </button>
            {/* <button
              type="button"
              onClick={handleReset}
              className="flex items-center gap-2 px-6 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2"
            >
              <X className="w-4 h-4" />
              Reset
            </button> */}
          </div>
        </form>
      </div>
    </div>
  );
};

export default HFCM;

